/*
* add React as wp.element so we can use wp.element.createElement as jsx pragma for gutenberg.
* This is necessary because we need to use the same jsx pragma for all entrypoints, so sharing components stays possible.
* */
const React = require('react')

window.wp = window.wp || {}
window.wp.element = window.wp.element || React
